// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import messages from './i18n/index'
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

import AudioRecorder from '@/components/toefl/audio/index'
Vue.use(AudioRecorder)
Vue.use(VueI18n)
/* i18n */
const navLang = navigator.language || navigator.userLanguage
let localLang = navLang || false
let lang = localLang ||  'en'
const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: lang,
  messages
})
/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

import './assets/css/common.css'

/* jquery */
import 'jquery'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from '@/components/common/Header'
Vue.component(Header.name, Header)

import headerTwo from '@/components/toefl/common/headerTwo'
Vue.component(headerTwo.name, headerTwo)

import headerTwoGre from '@/components/gre/common/headerTwo'
Vue.component(headerTwoGre.name, headerTwoGre)



/* 尾部组件 */
import Footer from '@/components/common/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
// import GoTop from './components/GoTop'

import store from './vuex/store'



// Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  next();
});

Vue.prototype.resetSetItem = function (key, newVal) {
     if (key === 'userName') {
          // 创建一个StorageEvent事件
         var newStorageEvent = document.createEvent('StorageEvent');
          const storage = {
              setItem: function (k, val) {
                  sessionStorage.setItem(k, val);
   
                // 初始化创建的事件
               newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

                 // 派发对象
                 window.dispatchEvent(newStorageEvent)
            }
        }
         return storage.setItem(key, newVal);
    }
 }
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/variables.scss'; 
import langElement from 'element-ui/lib/locale/lang/en'
import localeElement from 'element-ui/lib/locale'
localeElement.use(langElement)
Vue.use(ElementUI);

/**
 * 复制到剪贴板插件
 */
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

/**
 * 全局事件总线
 */
const bus = new Vue()
Vue.prototype.$bus = bus

Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if(sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      }else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      };

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离 
        const l = e.clientX - disX;
        const t = e.clientY - disY;

        // 移动当前元素  
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
})
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js